import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { NextHourForecast } from '../../../../core/api/api.entities';
import { WeatherApi } from '../../../../core/api/weather/weather-api.service';
import { MobileComponent } from '../../../../shared/components/mobile/mobile.component';

@Component({
  selector: 'app-weather-next-hour-forecast',
  templateUrl: './next-hour-forecast.component.html',
  styleUrl: './next-hour-forecast.component.scss',
})
export class NextHourForecastComponent extends MobileComponent implements OnInit {
  lastSync: Date = new Date();
  loading = true;
  nextHourForecast!: NextHourForecast;

  constructor(
    breakpointObserver: BreakpointObserver,
    private weatherApi: WeatherApi
  ) {
    super(breakpointObserver);
  }

  ngOnInit(): void {
    this.updateNextHourForecast();
    setInterval(() => this.updateNextHourForecast(), 300000);
  }

  get precipitation(): string {
    return `${this.nextHourForecast.precipitation} mm`;
  }

  get precipitationColour(): string {
    return this.nextHourForecast.precipitation > 0 ? 'indigo' : '';
  }

  get sunrise(): string {
    return new Date(this.nextHourForecast.sunrise).toTimeString().slice(0, 5);
  }

  get sunset(): string {
    return new Date(this.nextHourForecast.sunset).toTimeString().slice(0, 5);
  }

  get temperature(): string {
    return `${this.nextHourForecast.temperature.value} °C`;
  }

  get temperatureColour(): string {
    return this.nextHourForecast.temperature.value > 0 ? 'orange' : 'light-blue';
  }

  get temperatureFeelsLike(): string {
    return `${this.nextHourForecast.temperature.feelsLike} °C`;
  }

  get temperatureFeelsLikeColour(): string {
    return (this.nextHourForecast.temperature.feelsLike || 0) > 0 ? 'orange' : 'light-blue';
  }

  get tooltip(): string {
    return `Last synced at ${this.lastSync?.toLocaleTimeString()}`;
  }

  get weatherTypeImage(): string {
    return `../../../../assets/weather/${this.nextHourForecast.weatherType}.svg`;
  }

  get wind(): string {
    return `${this.nextHourForecast.wind.speed.toFixed(0)} (${this.nextHourForecast.wind.gust.toFixed(0)}) m/s ${
      this.nextHourForecast.wind.directionArrow
    }`;
  }

  private updateNextHourForecast(): void {
    this.loading = true;

    this.weatherApi.getNextHourForecast().subscribe(nextHourForecast => {
      this.lastSync = new Date();
      this.nextHourForecast = nextHourForecast;
      this.loading = false;
    });
  }
}
